import angular from 'angular';
import template from './textfield.html';
import controller from './textfield.controller';
import TextfieldComponent from './textfield.component';

const textfieldConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('textfield', {
		title:      'Text Field',
		template,
		icon:       'fa fa-terminal',
		controller,
		children:   false,
		selectable: true,
		settings:   new TextfieldComponent(),
		views: [
			{
				name:     'Display',
				template: 'kform/components/textfield/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/textfield/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/textfield/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
	});
};

export default angular.module('app').config(textfieldConfig);
